/**
 * Individualization Request.
 *
 * @group DRM
 *
 * @beta
 */
export const INDIVIDUALIZATION_REQUEST = 'individualization-request';
//# sourceMappingURL=INDIVIDUALIZATION_REQUEST.js.map